import { apiConfig } from '../config';
import { getFetch } from '../fetch';

import { LESSON_STATUS } from '../../../typings';

interface GetClessonsStatusesRequest
{
    clessonIds: number[];
}

export type GetClessonsStatusesResponse = Record<number, LESSON_STATUS>;

export function getClessonsStatuses(request: GetClessonsStatusesRequest): Promise<GetClessonsStatusesResponse> {
    const { apiGetClessonsStatuses } = apiConfig.getStaticUrls();

    return getFetch(apiGetClessonsStatuses, { clesson: request.clessonIds.join(',') });
}
